<template>
  <div class="prices">
    <div class="container search-query">
      <div class="query">{{Lang.get('js.services.your_query')}}: {{queryText}}</div>
      <div class="count" v-if="count !== 0">{{Lang.get('js.services.count')}}: {{count}}</div>
    </div>
    <div class="container" v-if="Object.keys(data).length > 0">
      <div class="row">
        <div class="col-12 col-md-3 left d-none d-lg-block">
          <div class="price-menu">
            <ul>
              <li v-for="(category, key) in data"
                  :key="key"
                  :class="{ active: currentCategory === key || currentCategory == category.name}"
                  @click="currentCategory = key">{{category.name}}</li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-md-9 block-info">
          <div class="static-info">
            <p>{{Lang.get('js.services.dop')}}</p>
          </div>
          <template v-for="(item, key) in data"
          >
            <ul class="d-block d-lg-none">
              <li @click="toggleCategory(key)"
                  :class="{ active: currentCategory === key}">{{item.name}}</li>
            </ul>
            <div v-if="key === currentCategory" class="my-table-info">
              <table>
                <thead>
                <tr>
                  <th>{{Lang.get('js.services.code')}}</th>
                  <th>{{Lang.get('js.services.type')}}
                  </th>
                  <!--                <th>Вид биоматериала-->
                  <!--                </th>-->
                  <th>{{Lang.get('js.services.time')}}
                  </th>
                  <th>{{Lang.get('js.services.price')}}</th>
                  <th v-if="checkDiscount(item.services)">{{ Lang.get('js.services.buy') }}</th>
                  <th v-else>{{ Lang.get('js.services.buy_without_discount') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td colspan="4"><strong>{{item.name}}</strong>
                  </td>
                </tr>
                <tr v-for="(service, index) in item.services">
                  <td>
                    {{service.code}}
                  </td>
                  <td style="width: 570px;">
                    <a :href="'/' + service.alias.url"
                       :title="service.name">
                      {{service.name}}</a>
                  </td>
                  <td>
                    {{service.lead_time ? service.lead_time :'-'}}
                  </td>
                  <td>
                    {{service.price}}
                  </td>
                  <td @click="goToCart(service)" style="cursor: pointer">
                    <span class="my-button cart-icon table-my-button" style="text-align: center"
                          v-html="getPriceWithDiscount(service.price) + ' грн.'"
                          v-if="service.discount === 1"
                    ></span>
                    <span class="my-button cart-icon table-my-button" style="text-align: center"
                          v-html="service.price + ' грн.'"
                          v-else
                    ></span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="container" style="font-size: 1.9rem;" v-else>{{Lang.get('js.services.no_result')}}</div>
  </div>
</template>

<script>
  export default {
      name: 'search-services-list',
      data() {
          return {
              currentCategory: 0,
              Lang,
              defaultLanguage,
              data: {},
              queryText,
              count,
            cart: window.cart

          }
      },
      methods: {
        checkDiscount(servicesArray) {
          let hasDiscount = true;
          servicesArray.forEach((service) => {
            if(service.discount === 0) {
              hasDiscount = false;
            }
          });

          return hasDiscount;
        },
        toggleCategory(key) {
          if (this.currentCategory === key) {
            this.currentCategory = '';
          } else {
            this.currentCategory = key;
          }
        },
        getPriceWithDiscount(initPrice) {
          initPrice = Math.round(parseFloat(initPrice * (100 - 10))) / 100;
          return initPrice;
        },
        // goToCart(code) {
        //     let url = 'http://artmediuz.medcloud.pro/?tests=' + code + '&tab=cart';
        //     window.open(url, '_blank');
        // },
        goToCart(service) {
          let price_with_discount = service.price;;
          if(service.discount === 1) {
            price_with_discount = this.getPriceWithDiscount(service.price);
          }

          this.cart.addToCart(service, price_with_discount);
        },
        setData() {
          this.data = services;
          if (!this.data.length && this.data.length !== 0) {
            let key;
            for (var k in this.data) {
              key = k;
              break;
            }
            this.currentCategory = this.data[key].name;
            if (document.documentElement.clientWidth <= 991) {
              this.currentCategory = '';
            } else {
              this.currentCategory = this.currentCategory ? this.currentCategory : 0;
            }
          }
        }
      },
      mounted() {
         this.setData();
      }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/service/SearchServicesList.vue